import {makeAutoObservable} from "mobx";
import {ViewController} from "data/types/structure";
import {injectable, inject} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import type {IRosterStore} from "data/stores/roster/roster.store";
import type {IContestsStore} from "data/stores/contests/contestsStore";
import {IRosterPlayer} from "data/types/roster";

export interface IRosterListLayoutViewTomorrowController extends ViewController {
	get contestId(): number;
	get rosterPlayers(): IRosterPlayer[];
}

@injectable()
export class RosterListLayoutViewTomorrowController
	implements IRosterListLayoutViewTomorrowController
{
	constructor(
		@inject(Bindings.LocalizationStore) public readonly i18n: ILocalizationStore,
		@inject(Bindings.RosterStore) private readonly _rosterStore: IRosterStore,
		@inject(Bindings.ContestsStore) private readonly _contestStore: IContestsStore
	) {
		makeAutoObservable(this);
	}

	get contestId(): number {
		return this._rosterStore.currentContestId || 0;
	}

	get rosterPlayers(): IRosterPlayer[] {
		return this._rosterStore.rosterPlayers;
	}
}
